import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import firebase from 'firebase'

firebase.initializeApp({
  apiKey: "AIzaSyCsJWg0CEPWOtaF4vZ4O_a1wQ-BZ5A1tVw",
  authDomain: "chatapp-807de.firebaseapp.com",
  projectId: "chatapp-807de",
  storageBucket: "chatapp-807de.appspot.com",
  messagingSenderId: "1003067866504",
  appId: "1:1003067866504:web:cf0a4f675985b7a801ce3d",
  databaseURL: "https://chatapp-807de-default-rtdb.asia-southeast1.firebasedatabase.app"
})

const db = firebase.database();


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

export { db };